import Loading from '../../../Common/Loading';
import { AgeGroup } from './AgeGroup';
import { CityOfBirth } from './CityOfBirth';
import { Ethnicity } from './Ethnicity';
import { Gender } from './Gender';
import { PlaceOfBirthType } from './PlaceOfBithType';
import { StateOfBirth } from './StateOfBitrh';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const Charts = () => {
    const { isLoading, data } = useProfileChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <Gender />
                <Ethnicity />
                <PlaceOfBirthType />
            </div>
            <div className="charts-side-by-side-dashboards">
                <AgeGroup />
                <StateOfBirth />
                <CityOfBirth />
            </div>
        </>
    );
};
